import { Badge, Button, Card } from "react-bootstrap";
import { formatAddress, googleAddress } from "../../Helpers/Property/propertyAddressFormatters";
import timeService from "../../services/time/timeService";
import { PropertyBookingEntry } from "../../Types/bookingTypes";
import { PropertyType } from "../../Types/propertyTypes";
import { TurnoverType } from "../../Types/turnoverTypes";
import { AdditionalServiceType } from "../../Types/additionalServiceType";
import { Link } from "react-router-dom";
import PropertyLinkIcon from "../PropertyEntry/PropertyLinkIcon";
import canAccess from "../../services/accessService/accessService";
import { BookingSourceIcon } from "../Bookings/BookingEntry/BookingEntry";

export default function CleaningEntry(
    props: {
        propertyInfo: PropertyType,
        bookingInfo?: PropertyBookingEntry,
        nextCheckIn?: PropertyBookingEntry,
        // nextCheckIn?: Date,
        nextCheckInToday?: boolean,
        checkedOutToday?: boolean,
        dayRef?: Date | string,
        onEdit?: (b: any) => void
        onCheckedOut?: (b: any) => void
        onReady?: () => void
        colorBg?: boolean
        emptyRef?: boolean
        additionalCleaning?: string
        turnoverInfo?: TurnoverType | null
        onTurnoverStatusChange?: (turnover: TurnoverType, newStatus: string) => void
        additionalServiceInfo?: AdditionalServiceType | null
        onAdditionalServiceStatusChange?: (service: AdditionalServiceType, newStatus: string) => void
    }
) {

    const {
        propertyInfo,
        bookingInfo,
        nextCheckIn,
        nextCheckInToday,
        checkedOutToday,
        dayRef,
        onEdit,
        onCheckedOut,
        onReady,
        colorBg,
        emptyRef,
        additionalCleaning = '',
        turnoverInfo,
        onTurnoverStatusChange,
        additionalServiceInfo,
        onAdditionalServiceStatusChange,
    } = props;

    const occupied = () => {
        const now = timeService.dateToMillis(new Date())
        if (bookingInfo) {
            const checkIn = timeService.dateToMillis(bookingInfo.checkIn)
            const checkOut = timeService.dateToMillis(bookingInfo.checkOut)
            if (now >= checkIn && now <= checkOut) {
                return true
            }
        }
        if (nextCheckIn) {
            const checkIn = timeService.dateToMillis(nextCheckIn.checkIn)
            const checkOut = timeService.createLuxonDate(nextCheckIn.checkIn).endOf('day').toMillis()
            if (now >= checkIn && now <= checkOut) {
                return true
            }
        }

        return !emptyRef //false
    }

    const isOccupied = occupied()

    let nights = 0
    if (bookingInfo) {
        nights = timeService.calculateNights(bookingInfo.checkIn, bookingInfo.checkOut)
    }

    let nextCheckInNights = 0
    if (nextCheckIn) {
        nextCheckInNights = timeService.calculateNights(nextCheckIn.checkIn, nextCheckIn.checkOut)
    }

    return (
        <Card
            className={`cleaning-entry mb-3`}
            style={{
                backgroundColor: colorBg ? isOccupied ? '#ffe9ec' : '#e8fbe8' : 'white',
            }}
        // bg={colorBg ? isOccupied ? 'warning' : 'success' : ''}
        // text={colorBg && !isOccupied ? 'light' : 'dark'}
        >
            <Card.Body>
                <Card.Subtitle className="fw-bold">
                    {propertyInfo.title}
                    <PropertyLinkIcon propertyId={propertyInfo._id} />
                </Card.Subtitle>


                {/* <Card.Title>{propertyInfo.title}</Card.Title> */}

                <Card.Link
                    className={`small text-decoration-none`}
                    // className={`small text-decoration-none ${colorBg && !isOccupied ? 'text-light' : 'text-dark'}`}
                    href={`${googleAddress(propertyInfo.address)}`}
                    target="_blank">
                    {formatAddress(propertyInfo.address)}
                </Card.Link>

                <Card.Text>


                    {additionalCleaning && (
                        <>
                            <Badge
                                bg={additionalCleaning === 'basic' ? 'info' : additionalCleaning === 'refresh' ? 'warning' : 'success'}
                                className="text-capitalize me-2"
                            >
                                {additionalCleaning} Cleaning
                            </Badge>
                            {bookingInfo && additionalCleaning === 'refresh' && (
                                <Badge bg='info' className="text-capitalize me-2">{bookingInfo.source}</Badge>
                            )}
                        </>
                    )}

                    {additionalServiceInfo && (
                        <Badge
                            bg={getServiceStatusVariant(additionalServiceInfo.status)}
                            className="text-capitalize me-2"
                        >
                            {additionalServiceInfo.status}
                            {/* Service: {additionalServiceInfo.status} */}
                        </Badge>
                    )}

                    {turnoverInfo && (
                        <>
                            <Badge
                                bg={getTurnoverStatusVariant(turnoverInfo.status)}
                                className="text-capitalize me-2"
                            >
                                {turnoverInfo.status}
                                {/* Turnover: {turnoverInfo.status} */}
                            </Badge>

                            {/* {!(turnoverInfo?.type === 'checkOut' && additionalCleaning === 'checkout') && (
                                <Badge bg="light" text="dark" className="text-lowercase me-2">
                                    {turnoverInfo.type}
                                </Badge>
                            )} */}
                        </>
                    )}

                    {(additionalCleaning || turnoverInfo || additionalServiceInfo) && <br />}

                    {/* <Badge bg={isOccupied ? 'danger' : 'success'}>
                        {isOccupied ? 'Occupied' : 'Vacant'}
                    </Badge>
                    <br /> */}

                    {dayRef && (
                        <>
                            {checkedOutToday && (
                                <>
                                    <Badge bg='danger'>Checked Out Today</Badge> <br />
                                </>
                            )}

                            {nextCheckInToday && (
                                <>
                                    <Badge bg='danger'>Next Check In Today</Badge> <br />
                                </>
                            )}

                            {nextCheckIn && (
                                <>
                                    <b>Empty Until:</b> {timeService.getFormattedTime(nextCheckIn.checkIn)} for {Math.floor(timeService.timeDiff(dayRef, nextCheckIn.checkIn))} days <br />
                                </>
                            )}
                            {/* : (
                                <>
                                    <b>Empty Until:</b> Unavailable <br />
                                </>
                            )} */}
                        </>
                    )}

                    {bookingInfo && (
                        <>
                            <b>Check In: </b> {timeService.getFormattedTime(bookingInfo.checkIn)} &nbsp; {nights > 0 ? (<small>(🌙{nights})&nbsp;</small>) : ''}
                            {timeService.isToday(bookingInfo.checkIn) ? (
                                <Badge bg='danger'>TODAY</Badge>
                            ) : ''} <br />

                            <b>Check Out:</b> {timeService.getFormattedTime(bookingInfo.checkOut)} &nbsp;
                            {timeService.isToday(bookingInfo.checkOut) ? (
                                <Badge bg='danger'>TODAY</Badge>
                            ) : ''} <br />

                            {canAccess('routes', 'edit-booking') && (
                                <>
                                    <b>Booking Source:</b> {bookingInfo.source}<BookingSourceIcon bookingInfo={bookingInfo} onlyIcon /><br />
                                </>
                            )}

                        </>
                    )}

                    {!bookingInfo && turnoverInfo && (
                        <>
                            <b>Scheduled:</b> {timeService.getFormattedTime(turnoverInfo.scheduledFor)} <br />
                        </>
                    )}

                    {!bookingInfo && additionalServiceInfo && (
                        <>
                            <b>Service Date:</b> {timeService.getFormattedTime(additionalServiceInfo.serviceDate)} <br />
                        </>
                    )}

                    {nextCheckIn && (
                        <>
                            <b>Next Check In:</b> {nextCheckIn ? (<>
                                {timeService.getFormattedTime(nextCheckIn.checkIn)} &nbsp;
                                {nextCheckInNights > 0 ? (<small>(🌙{nextCheckInNights})</small>) : ''}
                            </>) : 'UNAVAILABLE'} &nbsp;
                            {bookingInfo && timeService.isToday(bookingInfo.checkOut) && (
                                <>
                                    {timeService.sameDay(bookingInfo.checkOut, nextCheckIn.checkIn) ? (
                                        <Badge bg='danger'>SAME DAY</Badge>
                                    ) : ''}
                                </>
                            )} <br />
                        </>
                    )}


                </Card.Text>
            </Card.Body>

            {(!bookingInfo || (
                bookingInfo && (onEdit || onCheckedOut || onReady)
            ) || turnoverInfo || additionalServiceInfo) && (
                    <Card.Footer className="button-box">
                        {bookingInfo && (
                            <>
                                <div className="mt-2">
                                    {onEdit && (
                                        <Button
                                            className="me-2 mb-2"
                                            size="sm"
                                            variant="primary"
                                            onClick={() => {
                                                onEdit(bookingInfo)
                                            }}
                                        >Edit</Button>
                                    )}

                                    {onCheckedOut && (
                                        <Button
                                            className="me-2 mb-2"
                                            size="sm"
                                            variant="secondary"
                                            onClick={() => {
                                                onCheckedOut(bookingInfo)
                                            }}
                                        >Checked Out</Button>
                                    )}

                                    {onReady && (
                                        <Button
                                            className="me-2 mb-2"
                                            size="sm"
                                            variant="success"
                                            onClick={() => onReady()}
                                        >Ready</Button>
                                    )}
                                </div>
                            </>
                        )}
                        {!bookingInfo && !turnoverInfo && !additionalServiceInfo && (
                            <Link className="btn btn-sm btn-warning" to={`/inventory-check/${propertyInfo._id}`}>
                                Inventory
                            </Link>
                        )}
                        {turnoverInfo && onTurnoverStatusChange && (
                            <div className="mt-2">
                                {/* {turnoverInfo.status === 'new' && (
                                    <Button
                                        className="me-2 mb-2"
                                        size="sm"
                                        variant="secondary"
                                        onClick={() => onTurnoverStatusChange(turnoverInfo, 'pending')}
                                    >Mark Pending</Button>
                                )} */}
                                {(turnoverInfo.status === 'pending' || turnoverInfo.status === 'new') && (
                                    <Button
                                        className="me-2 mb-2"
                                        size="sm"
                                        variant="warning"
                                        onClick={() => onTurnoverStatusChange(turnoverInfo, 'started')}
                                    >Start</Button>
                                )}
                                {turnoverInfo.status === 'started' && (
                                    <Button
                                        className="me-2 mb-2"
                                        size="sm"
                                        variant="success"
                                        onClick={() => onTurnoverStatusChange(turnoverInfo, 'ready')}
                                        // onClick={() => onTurnoverStatusChange(turnoverInfo, 'completed')}
                                    >Complete</Button>
                                )}
                                {turnoverInfo.status === 'completed' && (
                                    <Button
                                        className="me-2 mb-2"
                                        size="sm"
                                        variant="info"
                                        onClick={() => onTurnoverStatusChange(turnoverInfo, 'ready')}
                                    >Mark Ready</Button>
                                )}
                                {turnoverInfo.status === 'ready' && (
                                    <Badge bg="success" className="me-2 mb-2 p-2">✓ Ready</Badge>
                                )}
                            </div>
                        )}
                        {additionalServiceInfo && onAdditionalServiceStatusChange && (
                            <div className="mt-2">
                                {/* {additionalServiceInfo.status === 'new' && (
                                    <Button
                                        className="me-2 mb-2"
                                        size="sm"
                                        variant="secondary"
                                        onClick={() => onAdditionalServiceStatusChange(additionalServiceInfo, 'pending')}
                                    >Mark Pending</Button>
                                )} */}
                                {(additionalServiceInfo.status === 'pending' || additionalServiceInfo.status === 'new') && (
                                    <Button
                                        className="me-2 mb-2"
                                        size="sm"
                                        variant="warning"
                                        onClick={() => onAdditionalServiceStatusChange(additionalServiceInfo, 'started')}
                                    >Start</Button>
                                )}
                                {additionalServiceInfo.status === 'started' && (
                                    <Button
                                        className="me-2 mb-2"
                                        size="sm"
                                        variant="success"
                                        onClick={() => onAdditionalServiceStatusChange(additionalServiceInfo, 'ready')}
                                        // onClick={() => onAdditionalServiceStatusChange(additionalServiceInfo, 'completed')}
                                    >Complete</Button>
                                )}
                                {additionalServiceInfo.status === 'completed' && (
                                    <Button
                                        className="me-2 mb-2"
                                        size="sm"
                                        variant="info"
                                        onClick={() => onAdditionalServiceStatusChange(additionalServiceInfo, 'ready')}
                                    >Mark Ready</Button>
                                )}
                                {additionalServiceInfo.status === 'ready' && (
                                    <Badge bg="success" className="me-2 mb-2 p-2">✓ Ready</Badge>
                                )}
                            </div>
                        )}
                    </Card.Footer>
                )}
        </Card>
    )
}

function getTurnoverStatusVariant(status: string) {
    switch (status) {
        case 'ready': return 'info'
        case 'completed': return 'success'
        case 'started': return 'warning'
        case 'pending': return 'secondary'
        case 'new': return 'dark'
        default: return 'secondary'
    }
}

function getServiceStatusVariant(status: string) {
    switch (status) {
        case 'ready': return 'info'
        case 'completed': return 'success'
        case 'started': return 'warning'
        case 'pending': return 'secondary'
        // case 'canceled': return 'danger'
        case 'new': return 'dark'
        default: return 'secondary'
    }
}